import { useEffect, useState } from "react";
import { Target } from "lucide-react";
import { toast } from "sonner";
import { api, errMsg } from "../lib/api";
import { Button } from "./ui/button";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "./ui/dialog";
import { Input } from "./ui/input";
import { Label } from "./ui/label";

export function RenewTargetDialog({ open, onOpenChange, routers, onSaved }) {
  const [def, setDef] = useState(80);
  const [per, setPer] = useState({});
  const [busy, setBusy] = useState(false);
  useEffect(() => { if (open) api.get("/ppp/evaluasi/target").then((r) => { setDef(r.data.default); setPer(r.data.per_router || {}); }).catch(() => {}); }, [open]);
  const save = async () => {
    setBusy(true);
    try {
      await api.put("/ppp/evaluasi/target", { default: Number(def) || 0, per_router: per });
      toast.success("Target perpanjangan disimpan"); onOpenChange(false); onSaved?.();
    } catch (e) { toast.error(errMsg(e)); } finally { setBusy(false); }
  };
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-md max-h-[85vh] overflow-y-auto" data-testid="dialog-renew-target">
        <DialogHeader><DialogTitle className="font-heading flex items-center gap-2"><Target className="w-5 h-5 text-emerald-500" /> Target Perpanjangan per Cabang</DialogTitle></DialogHeader>
        <p className="text-xs text-muted-foreground">Cabang dengan tingkat perpanjang di bawah target akan ditandai merah. Kosongkan kolom cabang untuk memakai target umum.</p>
        <div className="space-y-1.5"><Label>Target umum (%)</Label><Input type="number" min="0" max="100" value={def} onChange={(e) => setDef(e.target.value)} className="w-28" data-testid="target-default" /></div>
        <div className="space-y-1.5">
          <Label>Target khusus per cabang (%)</Label>
          <div className="max-h-64 overflow-y-auto divide-y divide-border rounded-lg border border-border">
            {routers.map((r) => (
              <div key={r.id} className="flex items-center justify-between gap-2 px-3 py-1.5 text-xs">
                <span className="truncate">{r.name}</span>
                <Input type="number" min="0" max="100" placeholder={String(def)} value={per[r.id] ?? ""} onChange={(e) => setPer({ ...per, [r.id]: e.target.value })} className="h-7 w-20 text-xs text-right" data-testid={`target-router-${r.id}`} />
              </div>
            ))}
          </div>
        </div>
        <Button onClick={save} disabled={busy} className="w-full bg-emerald-600 hover:bg-emerald-700 text-white" data-testid="target-save">{busy ? "Menyimpan..." : "Simpan Target"}</Button>
      </DialogContent>
    </Dialog>
  );
}
